<div
  class="contact-container rounded-lg"
  [formGroup]="form"
  (blur)="onTouched()"
>
  <app-form-field label="Contact Name">
    <app-input formControlName="name" placeholder="Enter name"></app-input>
  </app-form-field>

  <app-form-field label="Email">
    <app-input
      formControlName="email"
      type="email"
      placeholder="Enter email"
    ></app-input>
  </app-form-field>

  <app-form-field label="Phone">
    <div class="phone-ext-group rounded-lg">
      <app-input
        formControlName="phone"
        type="tel"
        placeholder="(000) 000-0000"
        variant="blend"
        class="flex-2/3"
      ></app-input>
      <div class="separator"></div>
      <app-number-input
        formControlName="ext"
        placeholder="Ext."
        class="ext-input flex-1/3"
        variant="blend"
        [min]="0"
        [max]="999999"
      />
    </div>
  </app-form-field>
</div>
